import { Component, computed, effect, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { ComponentsModule } from "@app/components/components.module";
import { SharedModule } from "@app/shared/shared.module";
import { NewStepperComponent } from "@app/new-flow/components/new-stepper/newstepper.component";
import { CommonModule } from '@angular/common';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectDataByKey, selectDataByKeyOrDefault } from 'src/storage/general.selectors';
import { removeData, setData } from 'src/storage/general.actions';
import { OrquestadorService } from '@app/services/orquestador/orquestador.service';
import { GeneralDataService } from '@app/services/general/general-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Home } from '@app/interfaces/home';
import { CUMULO } from '@app/routes.constants';
import { InactivityService } from '@app/services/inactivity/inactivity.service';
import { LoaderService } from '@app/services/general/loader.service';
import { LeadResumeSyncService } from '@app/services/lead-resume/lead-resume-store-sync.service';
import { LeadResumeService } from '@app/services/lead-resume/lead-resume.service';
import { DataLayerService } from '@app/services/dataLeyer/data-leyer.service';
import { ensureLeadResumeDataInStore, ensureCriticalDataBeforeSubmit } from '@app/utils/lead-resume-sync-helpers.util';
import { parsePropertyAddress, ParsedAddress } from '@app/utils/address-parser.util';
import { formatDateForSubmit, formatDateForInput } from '@app/utils/date-formatter.util';
import { setupComponentLoader, getSessionId, scrollToTop } from '@app/utils/component-helpers.util';
import {  ValidateAddress } from '@app/utils/validadors';

@Component({
  selector: 'app-new-inmueble',
  templateUrl: './new-inmueble.component.html',
  styleUrls: ['./new-inmueble.component.scss']
})
export class NewInmuebleComponent implements OnInit, OnDestroy {
  loaderService = inject(LoaderService);
  private leadResumeSyncService = inject(LeadResumeSyncService);
  private leadResumeService = inject(LeadResumeService);
  private _dataLayerService = inject(DataLayerService);
  inactivityKeys: ('PolicyHolder' | 'Tenant' | 'Property' | 'ProductCode')[] = ['PolicyHolder', 'Tenant', 'Property', 'ProductCode'];
  isModalOpen = false; // Controla si el modal está abierto o cerrado
  infoToastVisible = true;
  private infoToastTimeoutId: ReturnType<typeof setTimeout> | null = null;

  //Variables que capturan los datos de dirección del inmueble
  selectedType = signal('');
  street = signal('');
  streetNumber = signal('');
  complementNumber = signal('');
  apartment = signal('');
  neighborhood = signal('');
  //Concatena toda la dirección para mostrar el resumen
  directionSummary = computed(() => {
    return `${this.selectedType()} ${this.street()} ${this.street() ? "#" : ""} ${this.streetNumber()} ${this.streetNumber() ? "-" : ""} ${this.complementNumber()} ${this.apartment()} ${this.neighborhood()}
    `;
  })

  fb = inject(FormBuilder);
  store = inject(Store);
  orquestadorService = inject(OrquestadorService);
  generalDataService = inject(GeneralDataService);
  router = inject(Router);
  route = inject(ActivatedRoute);
  inactivityService = inject(InactivityService);

  ciudadseleccionada$: Observable<any>
  selectedObject: any = null;
  locations: any[] = [];
  ciudadesDepartamento: string[] = [];
  today = new Date().toISOString().split('T')[0];

  // Crear una nueva fecha sumando 31 días
  maxDateObj = new Date();
  maxDate: string = '';

  isValidAdress = signal(true);
  isClicked: boolean = false;
  isLoading: boolean = false;
  loaded: boolean = false;
  synced: boolean = false;
  sessionId: string = '';

  validityOptions: any = [
    { value: 'Anl', label: 'Anillo' },
    { value: 'Aut', label: 'Autopista' },
    { value: 'Av', label: 'Avenida' },
    { value: 'Av Cll', label: 'Avenida Calle' },
    { value: 'Av Cra', label: 'Avenida Carrera' },
    { value: 'Cll', label: 'Calle' },
    { value: 'Cra', label: 'Carrera' },
    { value: 'Cir', label: 'Circular' },
    { value: 'Circ', label: 'Circunvalar' },
    { value: 'Dg', label: 'Diagonal' },
    { value: 'Km', label: 'Kilómetro' },
    { value: 'Mz', label: 'Manzana' },
    { value: 'Tv', label: 'Transversal' },
    { value: 'Zn', label: 'Zona' }
  ]

  asessorCode$: Observable<any>;
  private subscriptions: Subscription = new Subscription();
  asesorCode: string = '';

  generatedBody: any;
  plan$: Observable<any>;
  planName: string = "";
  bodyEnvio: Home = { getInitialData: false };
  property$: Observable<any>;
  propertyDetail$: Observable<any>;


  constructor() {
    this.ciudadseleccionada$ = this.store.select(selectDataByKey('cityselected'));
    this.asessorCode$ = this.store.select(selectDataByKey('codigoAsesor'));
    this.plan$ = this.store.select(selectDataByKey('Plan'));
    this.property$ = this.store.select(selectDataByKey('Property'));
    this.propertyDetail$ = this.store.select(selectDataByKey('PropertyFormDataDetail'));

    effect(() => {
      this.direccionCompleta();
    });

    this.maxDateObj.setDate(this.maxDateObj.getDate() + 31);
    // Convertir la fecha máxima al mismo formato YYYY-MM-DD
    this.maxDate = this.maxDateObj.toISOString().split('T')[0];

  }


  ngOnInit(): void {

    this.inactivityService.stopTimer();

    this.sessionId = getSessionId().toString();

    // Configurar loader usando utility
    setupComponentLoader(this.loaderService, this.subscriptions, ({ loading, loaded }) => {
      this.isLoading = loading;
      this.loaded = loaded;
    });

    this.setupInfoToast();

    this.subscriptions.add(
      this.store.select(selectDataByKey('isLeadResume')).subscribe(isLeadResume => {
        console.log('🔄 Verificando flag isLeadResume en store:', isLeadResume);
        ;
        if (isLeadResume) {

          console.log('🔄 Flag de Lead Resume detectado en store - Ocultando botón volver', isLeadResume);

          // 🔹 IMPORTANTE: Sincronizar datos del Lead Resume ANTES de inicializar formulario
          // Esto asegura que los datos estén en el store cuando las suscripciones se ejecuten
          console.log('🔄 Sincronizando Lead Resume en datos-inquilino...');
          // this.synced = this.leadResumeSyncService.syncAllLeadResumeData();
          console.log('📊 Lead Resume sincronizado:', this.synced ? 'Sí' : 'No');
        }
      })
    );


    // // 🔹 Asegurar que todos los datos críticos estén en el store
    // if (this.synced) {
    //   ensureLeadResumeDataInStore(
    //     this.leadResumeService,
    //     this.leadResumeSyncService,
    //     this.store,
    //     'NewInmuebleComponent'
    //   );

    //   // 🔹 Marcar que vino de retoma (para que datos-propietario oculte botón volver)
    //   console.log('🔄 Lead Resume detectado - Marcando flag en store');
    //   this.store.dispatch(setData({
    //     key: 'isLeadResume',
    //     value: true,
    //     merge: false
    //   }));
    // }

    // Cargar locations primero (necesario para mapear ciudad/departamento)
    this.store.select(selectDataByKeyOrDefault('locations')).subscribe(data => {
      this.locations = data;

      console.log('Data locations recibida:', data);

      this.ciudadesDepartamento = data.map((item: any) => item.SURACiudadDepartamento__c);
      console.log('📍 Locations cargadas:', this.locations?.length || 0, 'ubicaciones');

      // // Si tenemos datos de Property del Lead Resume y locations ya están cargadas, cargar datos
      // if (this.synced && this.leadResumeSyncService.hasData('Property') && this.locations.length > 0) {
      //   const mappedData = this.leadResumeSyncService.getMappedData();
      //   if (mappedData?.Property) {
      //     console.log('✅ Cargando Property directamente desde Lead Resume con locations disponibles');
      //     this.loadPropertyData(mappedData.Property);
      //   }
      // }
    });


    this.subscriptions.add(
      this.plan$.subscribe(resume => {

        if (resume) {
          this.planName = resume.planName;
        }

      })
    );

    this.subscriptions.add(
      this.property$.subscribe(resume => {
        if (resume) {
          console.log('🏠 Property actualizado desde el store:', resume);
          this.loadPropertyData(resume);
        }
      })
    );

    // Suscribirse primero a PropertyFormData (datos guardados de formulario durante inactividad)
    this.store.select(selectDataByKey('PropertyFormData')).subscribe(resume => {
      if (resume) {
        console.log('Restaurando datos de formulario de inmueble desde PropertyFormData:', resume);

        // Restaurar todos los campos del formulario
        this.myForm.patchValue({
          ubicacion: `${resume.CityProperty} - ${resume.Department}`,
          tipoVia: resume.tipoVia || '',
          numVia: resume.numVia || '',
          currVia: resume.currVia || '',
          compVia: resume.compVia || '',
          apto: resume.apto || '',
          barrio: resume.barrio || '',
          resumenDireccion: resume.resumenDireccion || '',
          resumenDireccionFinal: resume.resumenDireccionFinal || '',
          fechaInicialContrato: resume.ContractStartDate ? formatDateForInput(resume.ContractStartDate) : '',
          flexCheckAutoriza: resume.flexCheckAutoriza || false
        });

        // Restaurar el objeto de ubicación seleccionado si existe
        if (resume.Code) {
          for (let loc of this.locations) {
            if (loc.SURACodigo__c === resume.Code) {
              console.log('Restaurando ubicación seleccionada del formulario:', loc);
              this.selectedObject = loc;
              break;
            }
          }
        }

      }
    });

    this.subscriptions.add(
      this.propertyDetail$.subscribe(resume => {
        if (resume) {
          // Solo actualizar si los campos están vacíos (evitar sobrescribir datos ya cargados)
          const currentApto = this.myForm.get('apto')?.value;
          const currentBarrio = this.myForm.get('barrio')?.value;

          this.myForm.patchValue({
            apto: resume.apto || '',
            barrio: resume.barrio || ''
          });
        }
      })
    );


    this.myForm.valueChanges.subscribe(value => {
      this.formValueSignal.set(value);
    });

    // Ocultar loader después de un breve delay para permitir que los datos se carguen
    setTimeout(() => this.loaderService.hide(), 500);

    // Iniciar timer de inactividad con callback para guardar datos del formulario
    this.inactivityService.startInactivityTimer(
      'seguros/hogar/arriendo/cotizador/inactividad',
      undefined,
      this.inactivityKeys,
      '35',
      'Abandono Inmueble',
      undefined,
      false,
      () => this.saveFormDataBeforeInactivity(), // Callback para guardar datos
      'Inmueble' // Nombre de la pantalla
    );

    this._dataLayerService.logDataNewFlow(
      'Arriendo_ecommerce_step_3_Datos_Inmueble',
      'Arriendo',
      'Datos_Inmueble',
      'Pageview',
      this.sessionId
    )


    console.log('CIUDADES', this.locations, this.ciudadesDepartamento)

  }


  myForm: FormGroup = this.fb.group({
    ubicacion: ['', Validators.required],
    tipoVia: [
      {
        value: '',
        disabled: false
      },
      [
        Validators.required,
      ]
    ],
    numVia: ['',
      [
        Validators.required,
        Validators.pattern('^[a-zA-ZñÑáéíóúÁÉÍÓÚüÜ0-9 ]+$'),
      ]
    ],
    currVia: ['',
      [
        Validators.required,
        Validators.pattern('^[a-zA-ZñÑáéíóúÁÉÍÓÚüÜ0-9 ]+$'),
      ]
    ],
    compVia: ['',
      [
        Validators.required,
        Validators.pattern('^[a-zA-ZñÑáéíóúÁÉÍÓÚüÜ0-9 ]+$'),
      ]
    ],
    apto: ['',
      [
        Validators.pattern('^[a-zA-ZñÑáéíóúÁÉÍÓÚüÜ0-9 ]+$'),
      ]
    ],
    barrio: ['',
      [
        Validators.pattern('^[a-zA-ZñÑáéíóúÁÉÍÓÚüÜ0-9 ]+$')
      ]
    ],
    resumenDireccion: [
      { value: '', disabled: true },
    ],
    resumenDireccionFinal: [
      '',
      this.ValidateEmail.bind(this),
      [
        // ValidateAddress()
      ]
    ],
    fechaInicialContrato: ['', Validators.required],
    flexCheckAutoriza: [false, Validators.requiredTrue]
  });

  formValueSignal = signal(this.myForm.value);

  ValidateEmail(control: AbstractControl): ValidationErrors | null {
    // Si la modal no está abierta, no validamos este campo
    if (!this.isModalOpen) {
      return null;
    }

    // Ejecutamos los validadores nativos de Angular
    const validators = [
      Validators.required,
      Validators.minLength(5),
      Validators.maxLength(100),
      Validators.pattern(/^[a-zA-ZñÑáéíóúÁÉÍÓÚüÜ0-9\s\#\-\.\,]+$/)
    ];

    for (const validator of validators) {
      const error = validator(control);
      if (error) {
        return error; // retorna el primer error encontrado
      }
    }

    return null; // válido
  }

  // Método para abrir el modal
  openModal() {
    const resumen = this.myForm.getRawValue().resumenDireccion;
    this.myForm.get('resumenDireccionFinal')?.setValue(resumen);
    this.isModalOpen = true;
    this.myForm.get('resumenDireccionFinal')?.updateValueAndValidity();

    this._dataLayerService.logDataNewFlow(
      'Arriendo_ecommerce_step_3_Datos_Inmueble',
      'Arriendo',
      'Datos_Inmueble',
      'Button',
      this.sessionId
    )
  }

  // Método para cerrar el modal
  closeModal() {
    this.isModalOpen = false;
  }
  closeModalButton() {
    this.isModalOpen = false;
    this.myForm.get('resumenDireccionFinal')?.updateValueAndValidity(); // refresca el estado del control
  }

  closeInfoToast(): void {
    this.infoToastVisible = false;
    this.clearInfoToastTimeout();
  }

  private setupInfoToast(): void {
    this.infoToastVisible = true;
    this.clearInfoToastTimeout();

    this.infoToastTimeoutId = setTimeout(() => {
      this.infoToastVisible = false;
      this.infoToastTimeoutId = null;
    }, 15000);
  }

  private clearInfoToastTimeout(): void {
    if (this.infoToastTimeoutId !== null) {
      clearTimeout(this.infoToastTimeoutId);
      this.infoToastTimeoutId = null;
    }
  }

  onOptionSelected(selectedObject: any) {
    console.log(selectedObject);
    this.selectedObject = selectedObject;

  }

  onSubmit() {
    // this.loaderService.show();
    this.isClicked = true;

    if (this.myForm.valid) {
      // 🔹 Asegurar datos críticos en el store antes de generar body
      // ensureCriticalDataBeforeSubmit(
      //   this.leadResumeService,
      //   this.leadResumeSyncService,
      //   this.store,
      //   'NewInmuebleComponent',
      //   false // No incluir Property porque se va a actualizar
      // );

      const datos = this.myForm.getRawValue();
      const formattedDate = formatDateForSubmit(datos.fechaInicialContrato);

      // Guardar en el store
      const Property: any = {
        ContractStartDate: formattedDate,
        Department: this.selectedObject ? this.selectedObject.SURADepartamento__c : '',
        CityProperty: this.selectedObject ? this.selectedObject.SURACiudad__c : '',
        // "RealEstateLicensePlate": "123456",
        PropertyAddress: datos.resumenDireccionFinal ? datos.resumenDireccionFinal : '',
        DepartmentCode: this.selectedObject ? this.selectedObject.SuraCodigoDepartamento__c : '',
        Code: this.selectedObject ? this.selectedObject.SURACodigo__c : '',
        CityCode: this.selectedObject ? this.selectedObject.SuraCodigoCiudad__c : '',
        RealEstateLicensePlate: datos.resumenDireccionFinal ? `${datos.resumenDireccionFinal} - ${this.selectedObject.SURACodigo__c}` : ''
      }


      const propertyDetail = {
        apto: datos.apto ? datos.apto : '',
        barrio: datos.barrio ? datos.barrio : ''
      }

      const ParsedAddress = parsePropertyAddress(Property.PropertyAddress);
      const PropertyFormDataArr = { ...Property, ...ParsedAddress };


      this.store.dispatch(removeData({key: 'Property'}));
      this.store.dispatch(removeData({key: 'PropertyFormData'}));
      this.store.dispatch(removeData({key: 'PropertyDetail'}));
      
      //debugger;
      this.store.dispatch(setData({ key: 'Property', value: Property, merge: true }));
      this.store.dispatch(setData({ key: 'PropertyFormData', value: PropertyFormDataArr, merge: true }));
      this.store.dispatch(setData({ key: 'PropertyDetail', value: propertyDetail, merge: true }));

      const options = {
        keys: ['PolicyHolder', 'Tenant', 'Property', 'ProductCode'],
        screenPercentage: '15',
        leadId: 'leadId',
        asesorCode: this.asesorCode !== '' ? this.asesorCode : undefined,
        // bitacoraId: this.bitacoraId !== '' ? this.bitacoraId : undefined

      };

      this.generalDataService.getbody(options).subscribe(body => {
        this.generatedBody = body;
        console.log('Generated body (datos-inmueble):', this.generatedBody);
        console.log('📋 leadId en body:', this.generatedBody.leadId ? `✅ ${this.generatedBody.leadId}` : '⚠️ No disponible');

        this.generatedBody.getCumulo = true;
      });

      scrollToTop();
      this.loaderService.show();

      // Llamar al orquestador y navegar a datos-inquilino
      this.orquestadorService.postOrquestador(this.generatedBody).subscribe({
        next: (response) => {
          //debugger;
          console.log(response.data)
          if (response.data.hasPolicies) {
            this.loaderService.hide();
            this.router.navigate(['seguros/hogar/arriendo/cotizador/poliza-activa'], { relativeTo: this.route.parent });
            // this.loaderService.hide();
            return;
          }
          // Navegar a datos-inquilino (sistema nuevo)
          this.loaderService.hide();
          this.inactivityService.stopTimer();
          this.router.navigate(['seguros/hogar/arriendo/cotizador/datos-inquilino'], { relativeTo: this.route.parent });
          // this.loaderService.hide();

        },
        error: (error) => {
          console.error('Error en orquestador:', error);
          // Manejar error si es necesario
        }
      });

    } else {
      this.myForm.markAllAsTouched();
    }



  }

  public validateAddressFields() {
    const fields = ['tipoVia', 'numVia', 'currVia', 'compVia'];
    const hasError = fields.some(field => {
      const control = this.myForm.get(field);


      if (control && control.invalid) {
        this.isValidAdress.set(false);
      } else {
        this.isValidAdress.set(true);
      }

      // return control && control.invalid;

    });

  }




  direccionCompleta = computed(() => {
    const value = this.formValueSignal();
    const { tipoVia, numVia, currVia, compVia, apto, barrio } = value;

    if (tipoVia || numVia || currVia || compVia || apto || barrio) {

      let direccion = `${tipoVia} ${numVia} ${currVia ? '#' : ''} ${currVia} ${compVia ? '-' : ''} ${compVia}`;
      if (apto) direccion += `, ${apto}`;
      if (barrio) direccion += `, ${barrio}`;

      this.myForm.patchValue({ resumenDireccion: direccion });
      console.log('Dirección completa actualizada:', direccion);


      return direccion;
    }

    return '';
  });




  /**
   * Guarda los datos actuales del formulario en el store antes de la redirección por inactividad
   */
  private saveFormDataBeforeInactivity(): void {
    console.log('Guardando datos del formulario de inmueble antes de inactividad');

    const datos = this.myForm.getRawValue();

    // Guardar todos los datos del formulario tal como están para restaurarlos después
    const PropertyFormData = {
      ubicacion: datos.ubicacion || '',
      tipoVia: datos.tipoVia || '',
      numVia: datos.numVia || '',
      currVia: datos.currVia || '',
      compVia: datos.compVia || '',
      apto: datos.apto || '',
      barrio: datos.barrio || '',
      resumenDireccion: datos.resumenDireccion || '',
      resumenDireccionFinal: datos.resumenDireccionFinal || '',
      fechaInicialContrato: datos.fechaInicialContrato || '',
      flexCheckAutoriza: datos.flexCheckAutoriza || false,
      // Guardar referencia al objeto de ubicación seleccionado
      selectedLocationCode: this.selectedObject ? this.selectedObject.SURACodigo__c : null
    };

    console.log('Datos de formulario a guardar:', PropertyFormData);

    this.store.dispatch(setData({ key: 'PropertyFormData', value: PropertyFormData, merge: true }));

    // También guardar en formato Property para el orquestador
    const formattedDate = datos.fechaInicialContrato ? formatDateForSubmit(datos.fechaInicialContrato) : '';
    const Property: any = {
      ContractStartDate: formattedDate,
      Department: this.selectedObject ? this.selectedObject.SURADepartamento__c : '',
      CityProperty: this.selectedObject ? this.selectedObject.SURACiudad__c : '',
      PropertyAddress: datos.resumenDireccionFinal ? datos.resumenDireccionFinal : datos.resumenDireccion,
      DepartmentCode: this.selectedObject ? this.selectedObject.SuraCodigoDepartamento__c : '',
      Code: this.selectedObject ? this.selectedObject.SURACodigo__c : '',
      CityCode: this.selectedObject ? this.selectedObject.SuraCodigoCiudad__c : '',
      RealEstateLicensePlate: datos.resumenDireccionFinal ? datos.resumenDireccionFinal : datos.resumenDireccion
    };

    this.store.dispatch(setData({ key: 'Property', value: Property, merge: true }));

    console.log('Datos de inmueble guardados en store:', { PropertyFormData, Property });
  }

  /**
   * Carga los datos de Property en el formulario
   * Método centralizado para evitar duplicación de código
   */
  private loadPropertyData(propertyData: any): void {
    if (!propertyData) {
      console.warn('⚠️ No hay datos de Property para cargar');
      return;
    }

    // ✅ No cargar si no hay ciudad (evita cargar datos incompletos del store)
    if (!propertyData.CityProperty || !propertyData.Department) {
      console.warn('⚠️ Property sin ciudad - No se cargan datos en el formulario');
      return;
    }

    console.log('🏠 Cargando datos de Property:', propertyData);

    // Parsear la dirección usando utility
    const addressParts = parsePropertyAddress(propertyData.PropertyAddress);
    console.log('📍 Dirección parseada:', addressParts);

    // Buscar la ubicación en el catálogo
    let selectedLocation = null;
    if (this.locations && this.locations.length > 0) {
      for (let loc of this.locations) {
        if (loc.SURACiudad__c === propertyData.CityProperty && loc.SURADepartamento__c === propertyData.Department) {
          selectedLocation = loc;
          this.selectedObject = loc;
          console.log('✅ Ubicación encontrada:', {
            ciudad: selectedLocation.SURACiudad__c,
            departamento: selectedLocation.SURADepartamento__c,
            codigo: selectedLocation.SURACodigo__c
          });
          break;
        }
      }
      if (!selectedLocation) {
        console.warn('⚠️ No se encontró ubicación para:', propertyData.CityProperty, '-', propertyData.Department);
      }
    } else {
      console.warn('⚠️ Locations no cargadas aún, la búsqueda se hará cuando se carguen');
    }

    // Formatear fecha si existe usando utility
    const formattedDate = formatDateForInput(propertyData.ContractStartDate || '');
    if (formattedDate) {
      console.log('📅 Fecha de contrato formateada:', formattedDate);
    }

    // Cargar datos en el formulario
    this.myForm.patchValue({
      ubicacion: `${propertyData.CityProperty} - ${propertyData.Department}`,
      tipoVia: addressParts.tipoVia,
      numVia: addressParts.numVia,
      currVia: addressParts.currVia,
      compVia: addressParts.compVia,
      apto: addressParts.apto,
      barrio: addressParts.barrio,
      resumenDireccion: propertyData.PropertyAddress,
      resumenDireccionFinal: propertyData.PropertyAddress,
      fechaInicialContrato: formattedDate,
      flexCheckAutoriza: true
    });


    this.today = formattedDate || this.today;

    console.log('✅ Formulario de inmueble cargado con datos de Property');
    console.log('📋 Valores cargados en formulario:', {
      apto: addressParts.apto,
      barrio: addressParts.barrio,
      tipoVia: addressParts.tipoVia,
      numVia: addressParts.numVia
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.inactivityService.stopTimer();
    this.clearInfoToastTimeout();
  }
}
